import React, {useEffect, useState} from "react";
import {Icon} from 'react-icons-kit';
import {eyeOff} from 'react-icons-kit/feather/eyeOff';
import {eye} from 'react-icons-kit/feather/eye';




import AppConfigurationTitle from "../../../components/header/AppConfigurationTitle";
import HtmlTagName from "../../../../utils/stringLiterals/HtmlTagName";
import UserManager from "../../../../businessLayer/managers/UserManager";
import JsTypeInspector from "../../../../serviceLayer/validators/JsTypeInspector";
import ProcessStatus from "../../../../utils/enumerations/ProcessStatus";
import ValidationService from "../../../../serviceLayer/validators/ValidationService";
import HttpStatusCode from "../../../../utils/httpProtocol/HttpStatusCode";
import HtmlElementFormatter from "../../../../utils/formatters/HtmlElementFormatter";
import AccessControlInspector from "../../../../serviceLayer/authorization/AccessControlInspector";

export default function MyProfile(props){
    const [isdisabled, setIsDisabled] = useState(true);
    const [notification, setNotification] = useState("");
    const [passwordErrors, setPasswordErrors] = useState("");
    const [confirmPasswordErrors, setConfirmPasswordErrors] = useState("");
    const [typePassword, setTypePassword] = useState(HtmlTagName.PASSWORD);
    const [iconPassword, setIconPassword] = useState(eyeOff);

    const [typeConfirmPassword, setTypeConfirmPassword] = useState(HtmlTagName.PASSWORD);
    const [iconConfirmPassword, setIconConfirmPassword] = useState(eyeOff);
    const [canDisplayPage, setCanDisplayPage] = useState(false);
    const [canUpdatePasswordCredentials, setCanUpdatePasswordCredentials] = useState(false);

    useEffect(()=>{
        setNotification("");
        setPasswordErrors("");
        setConfirmPasswordErrors("");
        setIsDisabled(false);
        processUserPermissions(props.resource.name, props.resource.actions);
    },[]);

    function processUserPermissions(resourceName , actions){
        const userCanDisplayPage = AccessControlInspector.userHasPermission(resourceName, actions._display_page);
        const userCanUpdatePasswordCredentials = AccessControlInspector.userHasPermission(resourceName, actions._update_password_credentials);
        setCanDisplayPage(userCanDisplayPage);
        setCanUpdatePasswordCredentials(userCanUpdatePasswordCredentials);
    }

    function onInputChangeEvent(event){
        //console.log("MyProfile-onInputChangeEvent-event", event);        
        event.preventDefault();
        clearInputs(event.target.name);
    }

    function onBlurEvent(event){
        //console.log("MyProfile-onBlurEvent-event" , event);
        event.preventDefault();
        clearInputs(event.target.name);
    }

    function togglePasswordVisibility(){
        if (typePassword=== HtmlTagName.PASSWORD ){
            setIconPassword(eye);
            setTypePassword( HtmlTagName.TEXT )
        } else {
            setIconPassword(eyeOff)
            setTypePassword(HtmlTagName.PASSWORD )
        }
    }

    function toggleConfirmPasswordVisibility(){
        if (typeConfirmPassword===HtmlTagName.PASSWORD){
            setIconConfirmPassword(eye);
            setTypeConfirmPassword(HtmlTagName.TEXT)
        } else {
            setIconConfirmPassword(eyeOff)
            setTypeConfirmPassword( HtmlTagName.PASSWORD)
        }
    }

    function onButtonClickEvent(event){
        //console.log("MyProfile-onButtonClickEvent-event" , event);
        event.preventDefault();
        //console.log("onButtonClickEvent-triggered-event", event);
        setIsDisabled(true);
        setNotification("");
        setPasswordErrors("");
        setConfirmPasswordErrors("");

        const report = UserManager.updatePassword(updatePasswordPageCallback);
        const reportIsValid = JsTypeInspector.objectIsValid(report); 
        if(reportIsValid &&  report.status === ProcessStatus.FailedWithErrors){
            setIsDisabled(false);
            processAllErrors(report);
        }
    }

    function updateFontColor(selectedClassName){
        const targetHtmlElementID = "password-update-notification-message1";
        const classesToBeRemoved = ["font-color-red", "font-color-darkblue"];
        const classesToBeAdded = [selectedClassName];

        HtmlElementFormatter.updateClassInHtmlElement(targetHtmlElementID, classesToBeRemoved, classesToBeAdded);
    }

    //#region Private Functions BEGIN    
    function clearInputs(inputName){
        
        if(inputName === HtmlTagName.PASSWORD){
            setPasswordErrors("");
        }

        if(inputName === HtmlTagName.CONFIRMPASSWORD){
            setConfirmPasswordErrors("");
        }
        setNotification("");
    }

    function processAllErrors(reportObj){
        const passwordErrorReport = ValidationService.processErrors(reportObj, HtmlTagName.PASSWORD);
        setPasswordErrors(passwordErrorReport);
        const confirmPasswordErrorReport = ValidationService.processErrors(reportObj, HtmlTagName.CONFIRMPASSWORD);
        setConfirmPasswordErrors(confirmPasswordErrorReport);        
    }

    function updatePasswordPageCallback(httpResponse){
        setIsDisabled(false);
        //console.log("updatePasswordPageCallback-httpResponse" , httpResponse);
        if(httpResponse.code === HttpStatusCode._400badRequest.code){
            const report = httpResponse.payload;
            updateFontColor("font-color-red");
            setNotification(httpResponse.payload.message);
            
            processAllErrors(report);
        }

        if(httpResponse.code === HttpStatusCode._200ok.code){
            updateFontColor("font-color-darkblue");
            setNotification(httpResponse.payload.message);
            
        }
    }
    //#region Private Functions END
   
    return(<div className="page-container  app-container container-flex-column"> 
                <AppConfigurationTitle path="/private/main" title="My Profile" />  
                {canDisplayPage && <> 
                    {canUpdatePasswordCredentials && <> 
                        <span className="my-profile-title"> Update Password</span>
                        <span id="password-update-notification-message1" className="notification-message" name={HtmlTagName.PASSWORD} dangerouslySetInnerHTML={{ __html: notification }}></span>
                        <form id="updatePasswordForm1" className="form-flex">
                            <div className="password-container">
                                <input id="email1" 
                                        type={typePassword} 
                                        name={HtmlTagName.PASSWORD} 
                                        onChange={onInputChangeEvent} 
                                        onBlur={onBlurEvent}
                                        placeholder="Password" 
                                        className="input-field input-h45"
                                />
                                <span className="toggle-password" onClick={togglePasswordVisibility}>
                                    <Icon className="mr-10" icon={iconPassword} size={25}/>
                                </span>
                            </div>
                            <span className="error-message" dangerouslySetInnerHTML={{ __html: passwordErrors }}></span>
                            <div className="password-container">
                                <input id="password1" 
                                        type={typeConfirmPassword}
                                        name={HtmlTagName.CONFIRMPASSWORD}
                                        onChange={onInputChangeEvent} 
                                        onBlur={onBlurEvent}
                                        placeholder="Confirm Password" 
                                        className="input-field input-h45 password-field"
                                />
                                <span className="toggle-password" onClick={toggleConfirmPasswordVisibility}>
                                    <Icon className="mr-10" icon={iconConfirmPassword} size={25}/>
                                </span>
                            </div>
                            
                            <span className="error-message" dangerouslySetInnerHTML={{ __html: confirmPasswordErrors }}></span>
                            <button type="button" 
                                    className="btn-element btn-h40 btn-w155" 
                                    disabled={isdisabled}
                                    onClick={(e)=>{onButtonClickEvent(e);}}>Update Password</button>
                        </form>
                        <div className="bottom"></div> 
                    </>}
                </>}  
            </div>
        );
}